<div
  [ngClass]="{ 'outline outline-anis': selected() }"
  class="relative size-full select-none overflow-hidden rounded-2xl">
  @if (image(); as image) {
    <app-image [image]="image" [isPriority]="isPriority()" [pregenerationSize]="{ width: 216, height: 190 }" />
  } @else {
    <div class="flex size-full justify-center bg-white pt-7">
      <app-svg [height]="110" [inline]="true" [width]="95" src="assets/icons/option-none.svg" />
    </div>
  }
  <div class="absolute inset-0 z-10 flex items-end p-2.5">
    @if (showCheckbox()) {
      <div class="absolute inset-0 p-2.5 text-right">
        <app-checkbox [(checked)]="selected" />
      </div>
    }
    <div
      class="drop-shadow-custom grid w-full grid-cols-[minmax(0,1fr)_auto] items-center gap-x-2.5 overflow-hidden rounded-lg bg-gray-light p-2">
      <span class="min-w-0 hyphens-auto break-words font-bold">{{ name() }}</span>
      <span
        (click)="handleEditButtonClick()"
        [class.cursor-pointer]="isInEditMode()"
        class="flex shrink-0 flex-nowrap gap-x-0.5">
        @if (isInEditMode()) {
          <app-svg [height]="18" [inline]="true" [width]="18" src="assets/icons/edit.svg" />
        } @else if (costLevel()) {
          @for (i of costLevel()! | generateRange; track i) {
            <app-svg [height]="21" [width]="21" src="assets/icons/badge-price.svg" />
          }
        } @else if (description()) {
          {{ description() }}
        }
      </span>
    </div>
  </div>
</div>
